export enum PokemonType {
    Normal = "normal",
    Fire = "fire",
    Water = "water",
    Electric = "electric",
    Grass = "grass",
    Ice = "ice",
    Fighting = "fighting",
    Poison = "poison",
    Ground = "ground",
    Flying = "flying",
    Psychic = "psychic",
    Bug = "bug",
    Rock = "rock",
    Ghost = "ghost",
    Dragon = "dragon",
    Dark = "dark",
    Steel = "steel",
    Fairy = "fairy",
}

const colors: Record<PokemonType, string> = {
    normal: '#A8A77A',
    fire: '#EE8130',
    water: '#6390F0',
    electric: '#F7D02C',
    grass: '#7AC74C',
    ice: '#96D9D6',
    fighting: '#C22E28',
    poison: '#A33EA1',
    ground: '#E2BF65',
    flying: '#A98FF3',
    psychic: '#F95587',
    bug: '#A6B91A',
    rock: '#B6A136',
    ghost: '#735797',
    dragon: '#6F35FC',
    dark: '#705746',
    steel: '#B7B7CE',
    fairy: '#D685AD',
}

export const getTypeColor = (type: string) => {
    const lowercaseType = type.toLowerCase() as PokemonType
    if (type.toLowerCase() in colors) {
        return colors[lowercaseType]
    }
    return "#000000"
}

export const pokemonNumberString = (num: number) => {
    if (num < 10) {
        return `00${num}`
    } else if (num < 100) {
        return `0${num}`
    } else {
        return `${num}`
    }
}